import { FormGroup, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

export default function TextFieldCustom({
  id, name, label, type, errorAndHelper, disabled, formik, value, onChange, multiline, pattern, mask, decimalScale, autocomplete = 'false',
}) {
  return (
    <FormGroup>
      <TextField
        // className={classes.textField}
        InputProps={mask && {
          inputComponent: mask,
        }}
        inputProps={{
          autocomplete: 'nada',
          maxlength: 100,
        }}
        inputLabelProps={{ style: { pointerEvents: 'auto', pattern: pattern || null }, shrink: true }}
        id={id}
        label={(
          <div>
            {label}
          </div>
        )}
        variant="outlined"
        disabled={disabled}
        name={name}
        type={type || 'text'}
        value={value}
        autocomplete={autocomplete}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={decimalScale || null}
        multiline={!!multiline}
        rows={multiline ? 4 : 1}
        onChange={onChange}
        onBlur={formik ? formik.handleBlur : null}
        error={formik ? formik.touched[errorAndHelper] && formik.errors[errorAndHelper] : null} // dois argumentos ta disparando o erro nos fomularios, o "error" aceita um tipo boleano e não string
        helperText={formik
          ? (formik.touched[errorAndHelper] && formik.errors[errorAndHelper]) : null}
        color="primary"
      />
    </FormGroup>
  );
}

TextFieldCustom.defaultProps = {
  id: 'textfield',
  label: 'Campo de Texto',
  type: 'text',
  errorAndHelper: '',
  formik: null,
  value: '',
  onChange: () => { },
  multiline: false,
  pattern: null,
  mask: null,
};

TextFieldCustom.propTypes = {
  /* id do campo de texto */
  id: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  errorAndHelper: PropTypes.string,
  formik: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func,
  multiline: PropTypes.bool,
  pattern: PropTypes.string,
  mask: PropTypes.string,
};
